import localeText from "../../../../../locale";
import { ORDERS_PER_CYCLE } from "./constants";

export const getOrdersProgressLabel = (ordersInCycle) =>
  localeText("extrapayFlowOrdersProgress", {
    current: Math.min(Number(ordersInCycle) || 0, ORDERS_PER_CYCLE),
    total: ORDERS_PER_CYCLE,
  });

export const getRemainingPurchasesLabel = (ordersInCycle) => {
  const remaining = Math.max(ORDERS_PER_CYCLE - (Number(ordersInCycle) || 0), 0);
  if (remaining === 0) return localeText("extrapayFlowCycleComplete");
  if (remaining === 1) return localeText("extrapayFlowOnePurchaseLeft");
  return localeText("extrapayFlowPurchasesLeft", { count: remaining });
};

export const getCycleProgressPercent = (ordersInCycle) => {
  const current = Math.min(Math.max(Number(ordersInCycle) || 0, 0), ORDERS_PER_CYCLE);
  return (current / ORDERS_PER_CYCLE) * 100;
};
